import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { getGroupCutlist, getOrderItemCutlist } from "../product/service";
import { CoreContainer } from "../common/style";
import { isBrowser } from "react-device-detect";
import { Notification } from "../common/style";

const Cutlist = ({ orderItemId, projectId, groupId, itemCutlists = null }) => {
  const [cutlists, setCutlist] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [detailedCutlistView, setDetailedCutlistView] = useState(false);

  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [priceSummary, setPriceSummary] = useState(false);

  const onDismissNotification = () => {
    setNotification({ type: "", message: "" });
    setIsNotificationVisible(false);
  };

  const orderItemCutlist = () => {
    return getOrderItemCutlist({
      orderItemId,
      projectId,
      groupId,
    })
      .then((cutlist) => {
        setCutlist(Object.values(cutlist).flat());
        setDetailedCutlistView(
          cutlist[0] && cutlist[0].hasOwnProperty("item_assembly_label")
        );
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const groupCutlist = () => {
    return getGroupCutlist({ projectId, groupId })
      .then((cutlist) => {
        setCutlist(Object.values(cutlist).flat());
      })
      .catch(({ error }) => {
        //TODO: Handle Error
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!itemCutlists) {
      orderItemId ? orderItemCutlist() : groupCutlist();
    } else {
      setCutlist(itemCutlists);
      setIsLoading(false);
    }
  }, []);

  if (notification.type) {
    return (
      <Notification
        color={notification.type === "error" ? "danger" : "success"}
        isOpen={isNotificationVisible}
        toggle={onDismissNotification}
      >
        {notification.message}
      </Notification>
    );
  }

  return isLoading ? (
    <CoreContainer height={isBrowser ? "70vh" : "50vh"}>
      <Spinner size="sm" style={{ margin: "auto" }}>
        Loading...
      </Spinner>
    </CoreContainer>
  ) : (
    <>
      {false && (
        <i
          className={`fa-solid fa-indian-rupee ${
            priceSummary && "text-primary"
          } pointer`}
          onClick={() => setPriceSummary(!priceSummary)}
        />
      )}
      <div className="overflow-hidden mt-3">
        {cutlists.map((cutlist, index) => (
          <div key={index}>
            {cutlist.panels.length > 1 && (
              <div
                className="d-flex justify-content-between align-items-center p-2 border-bottom border-secondary-subtle"
                style={{ background: "#E5E5E5" }}
              >
                <div className="d-flex align-items-center column-gap-2">
                  <div
                    className="text-white fw-bold bg-secondary rounded-circle"
                    style={{ padding: "3px 5px" }}
                  >
                    {cutlist.label}
                  </div>
                  <div className="text-capitalize">{cutlist.type}</div>
                </div>
                {priceSummary && (
                  <div className="fw-bold">
                    {cutlist.rate ? `₹${cutlist.rate}` : "Price Outdated"}
                  </div>
                )}
              </div>
            )}
            {cutlist.panels.map((panel, panelIndex) => (
              <div
                className="d-flex align-items-start column-gap-2 p-2 ps-4 border-bottom border-secondary-subtle"
                key={panelIndex}
                style={{
                  ...(cutlist.panels.length === 1 && {
                    background: "#E5E5E5",
                  }),
                }}
              >
                {cutlist.panels.length > 1 ? (
                  <div
                    className="text-secondary fw-bold border border-secondary rounded-circle"
                    style={{ padding: "0px 6px" }}
                  >
                    {panel.label}
                  </div>
                ) : (
                  <div
                    className="text-white fw-bold bg-secondary rounded-circle"
                    style={{ padding: "3px 5px" }}
                  >
                    {cutlist.label}
                  </div>
                )}
                <div className="w-100">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex column-gap-2">
                      <p className="m-0">{panel.name}</p>
                      {priceSummary ? (
                        cutlist.rate && (
                          <p className="m-0 text-secondary">
                            ₹{panel.price_and_wastage.rate}
                            {" (" + panel.price_and_wastage.wastage + "%)"}
                          </p>
                        )
                      ) : (
                        <p className="m-0 text-secondary">
                          {panel.thickness}mm
                        </p>
                      )}
                    </div>
                    {priceSummary ? (
                      cutlist.panels.length === 1 ? (
                        <p className="m-0 fw-bold">
                          {cutlist.rate ? `₹${cutlist.rate}` : "Price Outdated"}
                        </p>
                      ) : (
                        cutlist.rate && (
                          <p className="m-0 fw-bold">
                            ₹{panel.price_and_wastage.module_rate}
                          </p>
                        )
                      )
                    ) : (
                      <p className="m-0 text-secondary">
                        {panel.length_1} x {panel.length_2}
                      </p>
                    )}
                  </div>
                  <div className="d-flex justify-content-between align-items-start column-gap-4 mt-1">
                    <div className="text-secondary">
                      {panel.color_1}{" "}
                      {panel.color_1 !== panel.color_2 && `/ ${panel.color_2}`}
                      {panel.edges && ` | ${panel.edges}`}
                    </div>
                    {panel.grooves && (
                      <div className="px-1 text-secondary border border-secondary-subtle">
                        G
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default Cutlist;
